import React from "react";
var __jsx = React.createElement;
import stl from "./loader3d.module.css";
import Loader from "@componentsShared/Loader/Loader";
var Loader3d = function Loader3d() {
  return /*#__PURE__*/React.createElement("div", {
    className: stl.Loader3dContainer
  }, /*#__PURE__*/React.createElement(Loader, null));
};
export default Loader3d;